/* eslint-disable no-undef */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import './fonts/Cambon-Bold.ttf';
import './fonts/Graphik-Regular.ttf';
import './fonts/GraphikMedium.otf';

render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);
